import React from 'react';
import AuthorizationCall from "@components/API/AuthorizationCall";

const Authorization = () => {
    return (
        <AuthorizationCall />
    );
};

export default Authorization;